module.exports = __webpack_public_path__ + "static/media/tiktok.605fae89.svg";